import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c6ffe006"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings" }
const _hoisted_2 = { class: "settings_top" }
const _hoisted_3 = { class: "settings_box" }
const _hoisted_4 = {
  key: 0,
  class: "settings_box_item"
}

import userSet from './userSet.vue';

import { MenuProps } from 'ant-design-vue';
import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {


const activeKey = ref('1');


//初始tab选中0
const current = ref<string[]>(['0']);
//tab数据
const items = ref<MenuProps['items']>([
    {
        key: '0',
        label: '账号设置',
    }
]);




return (_ctx: any,_cache: any) => {
  const _component_a_menu = _resolveComponent("a-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_menu, {
        selectedKeys: current.value,
        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((current).value = $event)),
        mode: "horizontal",
        items: items.value
      }, null, 8, ["selectedKeys", "items"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      (current.value[0] === '0')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(userSet)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})